
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  AI,
  Answer,
  Candidate,
  CandidateResult,
  ReportShowConfigV5Item
} from "@/lib/model/exam/result";
import { replaceBgCheckString } from "@/utils/common";

@Component({})
export default class PaperResultReport extends Vue {
  @Prop({ default: () => new Candidate() }) candidate!: Candidate;
  @Prop({ default: () => new CandidateResult() }) all!: CandidateResult;
  @Prop({}) connectCode!: string;
  @Prop({ default: () => [] }) testList!: any;
  @Prop({}) getResLogo!: any;
  @Prop({}) hrResEnum!: any;
  @Prop({}) resultData!: any;
  @Prop({ default: () => [] }) paramList!: any;
  @Prop({ default: () => [] }) errorList!: any;
  @Prop({ default: () => [] }) paramListDIY!: any;
  colorRes = { 0: "#5654DC", 1: "#19C976", 2: "#2F91E7", 3: "#F72D20" };
  @Prop({ default: () => new ReportShowConfigV5Item() })
  option!: ReportShowConfigV5Item;

  replaceBgCheckString = replaceBgCheckString;

  created() {
    //
  }

  //
  mounted() {
    // this.isStudent = String(this.$route.query.ver || "") === "1";
  }
  // 文件类型
  isDownloadFileType(url: string): boolean {
    const downType = ["doc", "docx", "pptx", "ppt", "xls", "xlsx"];
    const type = url.split(".")[url.split(".").length - 1];
    console.log("type:", type, downType.includes(type));
    return downType.includes(type);
  }
  //打开简历
  showAttachment(url?: string) {
    const targetUrl = url || this.candidate.attachmentUrl;
    if (this.isDownloadFileType(targetUrl)) {
      window.location.href = targetUrl;
    } else {
      const h = window.outerHeight;
      const w = Math.max((window.innerWidth - 840) / 2, 540);
      const left =
        (window.screenX || window.screenLeft || 0) + window.innerWidth - w;
      window.open(
        targetUrl,
        "_blank",
        `height=${h}, width=${w}, top=0, left=${left}, toolbar=no, menubar=no, scrollbars=no,location=no, resizable=yes, directories=yes, status=no`
      );
    }
  }
  //头像占位
  defImg(event: any) {
    this.candidate.photoUrl = "";
    const img = event.srcElement;
    img.onerror = null; //防止闪图
  }

  //模块展示
  public Show(p: string) {
    return this.all.reportShowConfig?.[p] !== 1;
  }

  // 如果有命中了自动化规则的报告评价，则展示报告评价，不展示 errorList 的标签；
  // 如果没有命中自动化规则的报告评价，则按照原先的展示方式展示
  public get isShowAutoRuleReportComment() {
    return this.all.dimensionReportMessage.length > 0;
  }

  getShowReportCommentStyle(type: number) {
    let borderColor = "#59ABEC";
    let background = "rgba(89,171,236,0.2)";
    switch (type) {
      case 1:
        borderColor = "#9FC95D";
        background = "rgba(159,201,93,0.2)";
        break;
      case 2:
        borderColor = "#CB3D3D";
        background = "rgba(203,61,61,0.2)";
        break;
      case 3:
        borderColor = "#EAA552";
        background = "rgba(234,165,82,0.2)";
        break;
      case 4:
        borderColor = "#59ABEC";
        background = "rgba(89,171,236,0.2)";
        break;
      default:
        borderColor = "#59ABEC";
        background = "rgba(89,171,236,0.2)";
    }

    return {
      borderColor,
      background
    };
  }

  showReportComment() {
    return this.all.dimensionReportMessage.map(item => {
      return {
        ...item,
        style: this.getShowReportCommentStyle(item.messageType)
      };
    });
  }

  //HR阅过卷
  public get isHrChanged() {
    return (
      this.candidate.auditStatus !== 0 && this.candidate.auditMember !== "AI"
    );
  }

  //是否显示HR打分, true 展示  false 隐藏
  public get showHrScore() {
    return !this.option.optionMap.hiddenHrScore;
  }

  anchorTo(key: string, asArr?: boolean, pos = "center"): void {
    const refs = {
      faceCheck: "ref-cheat", //身份核验
      bgCheckSocial: "ref-bg", //社会安全
      bgCheckFinancial: "ref-bg", //金融风险
      bgCheck: "ref-bg", //背调结果
      bgCheckIdentity: "ref-bg", //手机号实名认证
      eyeColor: "ref-eyeColor", //辨色检测
      finger: "ref-finger", //手部检测
      faceDetection: "ref-cheat", //露脸检测
      replacePerson: "ref-cheat", //换人检测
      livenessRecognition: "ref-cheat", //人脸核验
      screenshot: "ref-cheat", //小程序防截屏检测
      mobileJoinCount: "ref-cheat", //小程序防切屏检测
      webJump: "ref-cheat", //Web防切屏检测
      readCheating: "ref-cheat", //念稿检测
      readingDetection: "ref-cheat"
    };
    const parent = this.$parent;
    if (parent) {
      const dom = parent.$refs[refs[key]];
      if (dom) {
        if (asArr) {
          dom[0].$el.scrollIntoView({
            behavior: "smooth",
            block: pos,
            inline: "nearest"
          });
        } else {
          dom[0].$el.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "nearest"
          });
        }
      }
    }
  }
}
